var map = {
	"./admin-board/admin-board.module": [
		"./src/app/admin-board/admin-board.module.ts",
		"common",
		"admin-board.module"
	],
	"./attendants/attendants.module": [
		"./src/app/admin-board/attendants/attendants.module.ts",
		"common",
		"attendants.module"
	],
	"./auth/auth.module": [
		"./src/app/auth/auth.module.ts",
		"common",
		"auth.module"
	],
	"./payments/payments.module": [
		"./src/app/admin-board/payments/payments.module.ts",
		"common",
		"payments.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_gendir lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_gendir lazy
// module id = ./src/$$_gendir lazy recursive
// module chunks = main